import { SectionHeader } from "./shared";
import linkIcon from "../../assets/home/resource-link.svg";

const RESOURCES = [
  { title: "Personal Loan for Salaried", desc: "Learn more about personal loan options for eligible salaried employees.", href: "/personal-loan-salaried-professionals" },
  { title: "Quick Personal Loan", desc: "Explore the digital application process for a quick personal loan.", href: "/quick-personal-loan" },
  { title: "Online Personal Loan", desc: "Learn about applying for a personal loan online.", href: "/online-personal-loan" },
  { title: "Personal Loan Up to ₹50,000", desc: "Explore personal loan options up to ₹50,000.", href: "/personal-loan-up-to-50000" },
  { title: "Personal Loan Eligibility", desc: "Understand the eligibility and assessment process.", href: "/personal-loan-eligibility" },
  { title: "Documents Required", desc: "Learn about the information and documents that may be required.", href: "/documents-required-for-personal-loan" },
];

export default function HomeResources() {
  return (
    <section className="bg-white px-4 sm:px-6 lg:px-[80px] py-[60px]">
      <div className="max-w-[1280px] mx-auto flex flex-col gap-10 lg:gap-14">
        <SectionHeader
          badge="Directories"
          title="Explore More"
          subtitle="Looking for more information about personal loans? Browse our curated guide list."
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 items-start">
          {RESOURCES.map((r, i) => (
            <a
              key={r.href}
              href={r.href}
              className="flex flex-col gap-3 bg-white border border-[#f3f4f6] rounded-[20px] p-6 transition-shadow hover:shadow-md"
            >
              <div className="flex items-center justify-between">
                <span className="font-extrabold text-[#10b981] text-[14px] tracking-[0.5px] uppercase">Resource #{i + 1}</span>
                <img alt="" src={linkIcon} className="size-[14px]" />
              </div>
              <p className="font-extrabold text-[#1a1a4b] text-[16px]">{r.title}</p>
              <p className="text-[#6a7282] text-[13px] leading-[18px]">{r.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
